/**
 * Progresso das mesclagens em andamento, por contato que fica (#4408).
 *
 * Recebe o mapa atual `{ [targetId]: { sourceId, moved, total } }` e um evento
 * `contactMerge`; devolve o mapa novo. `running` grava/atualiza, `done` e
 * `failed` tiram a barra. Evento inválido devolve o mesmo objeto (sem render).
 */
export const applyMergeProgress = (state, data) => {
  if (!data || data.targetId == null) return state;
  if (data.status === "running") {
    return {
      ...state,
      [data.targetId]: { sourceId: data.sourceId, moved: data.moved, total: data.total }
    };
  }
  if (!(data.targetId in state)) return state;
  const next = { ...state };
  delete next[data.targetId];
  return next;
};
